// extracted by mini-css-extract-plugin
export default {"lineTableAccEve":"colheita-section_lineTableAccEve__QAXXk","lineGridData":"colheita-section_lineGridData__xlvYk"};